module.exports = __webpack_public_path__ + "img/float-btn-esports.ef8b5acd.svg";